export default __webpack_public_path__ + "static/media/logo-new.6e629609.png";